export default __webpack_public_path__ + "static/media/E30.d28d20ca.jpg";